module.exports = __webpack_public_path__ + "img/borderRightTriangleWhite.59e319a6.svg";